export default {
  spartaCampaign: require("@/graph/campaign/campaignUsage.gql").default,
  spartaSubscription: require("@/graph/subscription/collection.gql").default,
  spartaUsers: require("@/graph/users/collection.gql").default
};
